import { render, staticRenderFns } from "./onlineUserDetails.vue?vue&type=template&id=70e83b6d&scoped=true"
import script from "./onlineUserDetails.vue?vue&type=script&lang=js"
export * from "./onlineUserDetails.vue?vue&type=script&lang=js"
import style0 from "./onlineUserDetails.vue?vue&type=style&index=0&id=70e83b6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e83b6d",
  null
  
)

export default component.exports